import { KeyClient } from '../types'
import { GetKeyPayload } from '../types/KeyClient'

export const getKey = (base: KeyClient) => async (id: string) => {
  return await base.requester.get<GetKeyPayload>(`/${id}`, { withCredentials: true });
};
